import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=4ad8b45e&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=4ad8b45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8b45e",
  null
  
)

export default component.exports